import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "~components/Form/components/Select";
import { ArrowRightModal } from "~misc/icons";
import { initialPath } from "~misc/paths";
import Loader from "~components/Form/components/Loader";
import useFilial from "~/fetchs/useFilial";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import useProdutoFilialPrecoRegraMicrorregiao from "~/fetchs/useProdutoFilialPrecoRegraMicrorregiao";

import { saveLocalStorage } from "~services/utils/SaveIndexBD";

const NovaNegociacaoModal = ({ isOpen, onClose, cliente }) => {
  const { id: idCliente } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const formikRef = useRef();

  const { filiaisDisponiveis, gruposMateriaisDisponiveis, produtosDisponiveis, setFilialId, setGrupoMaterialId } =
    useProdutoFilialPrecoRegraMicrorregiao({ microrregiaoId: cliente?.microrregiaoId });

  const { optionFiliais, onChangeFilial, filialSelect, filial } = useFilial({
    formikRef,
    filiaisDisponiveis,
    camposOpt: ["codigo", "nome"],
  });
  const { optionGruposProduto, grupoProduto, onChangeGrupoProduto, grupoProdutoSelect } = useGrupoProduto({
    formikRef,
    name: "grupoProdutoId",
    filial,
    gruposDisponiveis: gruposMateriaisDisponiveis,
    camposOpt: ["nome"],
  });
  const { optionProdutos, onChangeProduto, produtoSelect, produto } = useProduto({
    grupoProduto,
    formikRef,
    name: "produtoId",
    filialForm: filial,
    produtosDisponiveis: produtosDisponiveis,
    camposOpt: ["codigo", "descricaoProduto"],
  });

  useEffect(() => {
    setFilialId(filial);
  }, [filial, setFilialId]);

  useEffect(() => {
    setGrupoMaterialId(grupoProduto);
  }, [grupoProduto, setGrupoMaterialId]);

  const initialValues = {
    filialId: 0,
    grupoProdutoId: 0,
    produtoId: 0,
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={(e) => {
        if (onClose && typeof onClose == "function") onClose(e);

        setTimeout(() => {
          onChangeFilial({ label: null, value: null }, false);
          onChangeGrupoProduto({ label: null, value: null }, false);
          onChangeProduto({ label: null, value: null }, false);
        }, 100);
      }}
      size="xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent className="!rounded-[20px]">
        <ModalHeader />
        <ModalCloseButton className="!bg-[#FF2E00] !text-white !top-0 !right-0 !rounded-b-none !rounded-tl-none !rounded-tr-[20px] !w-10 !h-10" />
        <ModalBody>
          <Heading as="h4" className="font-bold !text-2xl text-center mx-auto" maxWidth="400px" mb="8">
            Selecione as informações necessárias para cadastrar nova negociação
          </Heading>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            onSubmit={async (values) => {
              try {
                setLoading(true);
                saveLocalStorage("dados-selecionados-negociacao", values, true);
                navigate(`${initialPath}/tabela-preco/${idCliente}/nova-negociacao`).then(() => {
                  setLoading(false);
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            {({ errors, touched }) => (
              <Form className="relative">
                <div className={loading ? "relative spinner__form-active" : "relative"}>
                  <Select
                    name="filialId"
                    label="Centro/Filial"
                    placeholder=""
                    options={optionFiliais}
                    noOptionsMessage="Centro/Filial não encontrado"
                    onChange={(e) => onChangeFilial(e)}
                    errors={errors?.filialId}
                    touched={touched?.filialId}
                    {...filialSelect}
                  />
                  <Select
                    name="grupoProdutoId"
                    label="Grupo de Produto"
                    placeholder=""
                    options={optionGruposProduto}
                    noOptionsMessage="Grupo de produto não encontrado"
                    onChange={(e) => onChangeGrupoProduto(e)}
                    errors={errors.grupoProdutoId}
                    touched={touched.grupoProdutoId}
                    isDisabled={!filial}
                    {...grupoProdutoSelect}
                  />
                  <Select
                    name="produtoId"
                    label="Produto"
                    placeholder=""
                    options={optionProdutos}
                    noOptionsMessage="produto não encontrado"
                    onChange={(e) => onChangeProduto(e)}
                    errors={errors.produtoId}
                    touched={touched.produtoId}
                    isDisabled={!grupoProduto}
                    {...produtoSelect}
                  />
                  <Button
                    type="submit"
                    variant="ghost"
                    className="ml-auto !table my-6"
                    _hover={{ background: "transparent" }}
                    disabled={loading || !filial || !grupoProduto || !produto}
                  >
                    <ArrowRightModal />
                  </Button>
                </div>
                {loading && (
                  <div className="spinner__form ">
                    <Loader />
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

NovaNegociacaoModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  cliente: PropTypes.object,
};

export default NovaNegociacaoModal;
